import {
    IBlankPageService,
} from './blank-page-service.interface';
import ua from '@tencent/docs-user-agent';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { openUrlForAll } from '@src/slide/infrastructure/module/independent/url/open-url';

const BLANKPAGE_STORE_KEY = 'blankPageData';

export class BlankPageService implements IBlankPageService {
    public constructor() {}

    public showBlankPage(docId: string): void {
        const clientVars = SlideDataServices.ClientVarsService()?.getClientVars?.();
        const sourcePadType = clientVars?.padType ?? 'slide';
        const blankPageData = {
            docId,
            sourcePadType,
        };
        localStorage.setItem(BLANKPAGE_STORE_KEY, JSON.stringify(blankPageData));

        // 跳转时， url参数不能丢， 比如jumpuin
        const newUrl = `${location.origin}/blankpage/${docId}${location.search}`;
        // app内 unload 监听不到
        if (ua.isTencentDocsApp) {
            window.dispatchEvent(new Event('unload'));
        }
        openUrlForAll({
            url: newUrl,
            replace: true,
            noHistory: true,
        });
        // location.replace(location.href.replace(/\/slide\//, '/blankpage/'));
        window.log?.info('BlankPage - navigator');
    }
}
